import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {TeamCompaniesService} from '../../../services/teamcompanies/teamcompanies.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UntypedFormBuilder, UntypedFormControl, Validators} from '@angular/forms';

@Component({
    selector: 'app-setteamcompanydialog',
    templateUrl: './setteamcompanydialog.component.html',
    styleUrls: ['./setteamcompanydialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SetTeamCompanyDialogComponent implements OnInit {

  public companies: any;
  public form: any;
  public dialogData;

  constructor(
      private teamCompaniesService: TeamCompaniesService,
      private formBuilder: UntypedFormBuilder,
      public dialogRef: MatDialogRef<SetTeamCompanyDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: SetTeamCompanyComponentModel
  ) {
    this.dialogData = data;
  }

  ngOnInit(): void {
    this.teamCompaniesService.getCompanies().then(companies => {
      const companyTypes = this.dialogData.companyTypes.length ? this.dialogData.companyTypes : (this.dialogData.teamMode ? ['employer'] : []);
      this.companies = companyTypes.length
        ? companies.filter((company: { type: string; }) => companyTypes.includes(company.type))
        : companies;
      const selectedCompanyId = this.companies.find((company: { id: string; }) => company.id === this.dialogData.companyId)
        ? this.dialogData.companyId
        : '';
      this.form = this.formBuilder.group({
        company: new UntypedFormControl(selectedCompanyId, [Validators.required]),
      });
    });
  }

  onDismiss(): void {
    this.dialogRef.close(undefined);
  }

  removeCompany(): void {
    this.dialogRef.close('');
  }

  setCompany(): void {
    this.dialogRef.close(this.form.get('company')?.value);
  }

}

export class SetTeamCompanyComponentModel {
  constructor(
      public companyId: string,
      public title: string,
      public info: string,
      public setButton: string,
      public removeButton: string,
      public teamMode: boolean,
      public companyTypes: string[] = []
  ) {
  }
}
